// extracted by mini-css-extract-plugin
export default {"back":"sDiN_2jZ"};